import ProductTraceabilityMap from "./productTraceabilityMap.container"

export default ProductTraceabilityMap
